import { z } from 'zod';
import { WATCHLIST as localStorageKey } from '../KEYS';

const schema = z.array(z.string());

const StoredWatchlist = {
  get(): string[] {
    const raw = localStorage.getItem(localStorageKey);
    // Stryker disable next-line ConditionalExpression: equivalent — JSON.parse(null) is rejected by the schema into the same empty list
    if (raw === null) return [];
    try {
      const parsed = schema.safeParse(JSON.parse(raw));
      return parsed.success ? parsed.data : [];
    } catch {
      return [];
    }
  },

  set(symbols: string[]): void {
    localStorage.setItem(localStorageKey, JSON.stringify(symbols));
  },
};

export default StoredWatchlist;
